import { render, staticRenderFns } from "./FlightList.vue?vue&type=template&id=8b5b20ae"
import script from "./FlightList.vue?vue&type=script&lang=js"
export * from "./FlightList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports